import clsx from 'clsx';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { ReactNode } from 'react';

type NavLinkProps = {
  href: string;
  children: ReactNode;
  className?: string;
  activeClassName?: string;
  exact?: boolean;
};

const NavLink = ({
  href,
  children,
  className = '',
  activeClassName = 'active',
  exact = false
}: NavLinkProps) => {
  const { pathname } = useRouter();

  const isActive = exact ? pathname === href : pathname.startsWith(href);

  return (
    <Link href={href} passHref>
      <a
        className={clsx({
          [className]: true,
          [activeClassName]: isActive
        })}
      >
        {children}
      </a>
    </Link>
  );
};

export default NavLink;
